// API
const API_SAFEA_AUTH      = '/auth';
const API_SAFEA_USERS     = '/users';
const API_SAFEA_SETTINGS  = '/settings';

import { STORAGE_TYPES } from '~/helpers/_core/storage';

export default {
  API_SAFEA_AUTH,
  API_SAFEA_USERS,
  API_SAFEA_SETTINGS,
  /** @deprecated Get the value directly from helper/_core/storage */
  LOCAL_STORAGE_IMPERSONATE          : STORAGE_TYPES.IMPERSONATE,
  /** @deprecated Get the value directly from helper/_core/storage */
  LOCAL_STORAGE_SIGNOUT_REDIRECT_URL : STORAGE_TYPES.SIGNOUT_REDIRECT_URL
};
